import { useCallback } from "react";

import type { VoucherInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import * as Query from "../../query";
import { VoucherUpdate_EditPage_Mutation } from "../schema/voucher-update";

export const useVoucherUpdateMutation = () => {
	const { mutationFunc } = useCustomMutation(VoucherUpdate_EditPage_Mutation);
	const onVoucherUpdate = useCallback(
		(input: VoucherInput) =>
			mutationFunc({
				variables: {
					input,
				},
				refetchQueries: [
					{
						query: Query.Schema.Voucher_EditPage_Query,
						variables: {
							voucherID: input.voucherID,
						},
					},
				],
			}),
		[mutationFunc],
	);

	return { onVoucherUpdate };
};
